export const CommuteMethods = ['driving', 'public_transport', 'cycling', 'walking'] as const;
export type CommuteMethod = (typeof CommuteMethods)[number];

type CommuteDestination = {
  placeId: string;
  label: string;
};

export type Commute = {
  destination: CommuteDestination | null;
  method: CommuteMethod;
  time: number;
};
